<template>
  <div class="container">
    <div class="main">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-dynamic"
        size="mini"
      >
        <el-form-item :label="$t('login.reset.label3')" prop="password">
          <el-input v-model="ruleForm.password" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.reset.label4')" prop="confirmPassword">
          <el-input v-model="ruleForm.confirmPassword" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { changePassword } from "../../../../api/personInfo.js";
export default {
  data() {
    var validatorPassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(this.$t("person.password.passwordRule")));
      } else {
        callback();
      }
    };
    var validatorRePassword = (rule, value, callback) => {
      const string = this.ruleForm.password;
      if (string !== value) {
        callback(new Error(this.$t("person.password.confirmRule")));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        password: "", //新密码：
        confirmPassword: "", //确认新密码：
      },
      rules: {
        password: [
          { required: true, message: this.$t("common.rules.newPassword") },
          { validator: validatorPassword },
        ], //新密码：
        confirmPassword: [
          { required: true, message: this.$t("common.rules.confirmPassword") },
          { validator: validatorRePassword },
        ], //确认新密码
      },
    };
  },
  methods: {
    async submitForm() {
      try {
        const { data } = await changePassword(this.ruleForm);
        if (data.code === 200) {
          this.$router.push("/adminLogin");
        }
      } catch (err) {
        console.log(err.message);
      }
    },

    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message.error(this.$t("common.require"));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  padding-top: 25px;
  .main {
    background-color: white;
    padding: 15px;
    height: 62vh;
  }
}
</style>
<style scoped>
.el-input >>> .el-input__inner {
  height: 36px;
}
.el-button {
  width: 88px;
  height: 32px;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.el-input >>> .el-input__suffix {
  right: 50px;
}
</style>
